<template>
  <Application>
    <b-breadcrumb :items="items"></b-breadcrumb>
  </Application>
</template>

<script>
import Application from '@/components/Application/Application.vue';

export default {
  components: {
    Application,
  },

  data() {
    return {
      loading: false,
      items: [
        { text: 'Dashboard', to: '/' },
        { text: 'Relatórios', active: true },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>

</style>
